

















import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import { ResourceHelper } from "@/helper/resourceHelper"
import { FontManager } from '@/model/fontManager/fontManager';
import { DebugHelper } from "@/helper/debugHelper";

import * as def from "@/definitions";
import { FontFamily } from "@/model/fontManager/fontFamily/fontFamily";
import DropdownList from "../dropdownList/dropdownList.vue";
import ArrowDown from "./resources/arrowDown.vue";

@Component({
  components: {
      ArrowDown,
      DropdownList
  }
})
export default class FontSelector extends Vue 
{
    @Prop({default:null}) selectedFontId! : string | null;
    @Prop({default:true}) isLocalFontAvailable! : boolean;

    isInputUnlocked = false;
    isTextEditorLocked = false;

    isFontDropdownActive : boolean = false;
    setFontDropdownActive(isActive : boolean)
    {
        if(isActive == this.isFontDropdownActive) return;
        this.isFontDropdownActive = isActive;
        this.$emit("dropdownListVisibleChanged", isActive);
    } 

    private setFontId(index: number, tag: string)
    {
        this.setFontDropdownActive(false);

        if(0 <= index && index < this.fontDropdownItems.length)
        {
            let fontId = this.fontDropdownItems[index].fontId;
            this.$emit("select", fontId);
        }
    }

    mounted() 
    {
        this.updatefontDropdownItems();
    }

    fontDropdownItems : Array<{
        id : number,
        label : string,
        isSelected : boolean,
        fontId : string
    }> = [];
    private updatefontDropdownItems(words = "")
    {
        var items = new Array();
        var fontManager : FontManager = this.$store.getters.fontManager;
        let idx = 0;
        for(var i = 0; i < fontManager.getFontNumber(); ++i)
        {
            var font = fontManager.getFontFamily(i);
            // ローカルフォントが使用できない場合は飛ばす
            if(!this.isLocalFontAvailable && font.isLocalFont) continue;
            // boldは読み飛ばす
            if(!font.isLocalFont && font.weight == 700) continue;
            if(words != "")
            {
                // 検索ワードがある場合
                let wordsLower = words.toLowerCase();
                let displayNameLower = font.displayName.toLowerCase();
                // 検索ワードが含まれない名称のフォントは飛ばす
                if(displayNameLower.indexOf(wordsLower) < 0) continue;
            }
            items.push({ id: idx, label: font.displayName, isSelected: this.selectedFontId == font.id, fontId : font.id });
            idx++;
        }
        this.fontDropdownItems = items;
    }

    private get fontName()
    {
        if(this.selectedFontId == null) return "";
        var fontManager : FontManager = this.$store.getters.fontManager;
        return fontManager.getFontFamilyById(this.selectedFontId).displayName;
    }

    // TextEditorのfocusLockを解除する
    private unlockTextEditorFocus()
    {
        if(this.isInputUnlocked) return;
        // アンロック時のテキスト入力状態を保持する
        this.isTextEditorLocked = document.activeElement != null && document.activeElement.id == "inline-text-editor-textarea";
        // メッセージセンター取得
        var messageCenter = this.$store.getters.messageCenter;
        // メッセージセンターに送信
        messageCenter.send("unlock_text_editor_focus", null);
        // アンロック済みフラグON
        this.isInputUnlocked = true;
    }

    private lockTextEditorFocus()
    {
        if(this.isTextEditorLocked)
        {
            // アンロック時にテキストエディターがロックされていた場合、ロックを復帰する
            // メッセージセンター取得
            var messageCenter = this.$store.getters.messageCenter;
            // メッセージセンターに送信
            messageCenter.send("lock_text_editor_focus", null);
        }
        // アンロック済みフラグOFF
        this.isInputUnlocked = false;
    }

    private chengeInputMode(mode)
    {
        DebugHelper.trace("inputmode")
        this.$store.dispatch("changeInputMode", mode);
    }

    private fixText()
    {
        this.$emit("doCommand", "fixText");
    }

    private showFontDropdown()
    {
        this.updatefontDropdownItems();
        this.setFontDropdownActive(true);
        this.addKeydownEventListener();
    }

    private addKeydownEventListener()
    {
        document.addEventListener("keydown", this.onKeyDownEvent);
    }

    private removeKeydownEventListener()
    {
        document.removeEventListener("keydown", this.onKeyDownEvent);
    }

    private onKeyDownEvent(e : KeyboardEvent)
    {
        let input = this.$refs["fontname-input"] as HTMLInputElement;
        if(document.activeElement == null || input != document.activeElement)
        {
            // フォント名入力にフォーカスがない場合はフォーカスする。
            this.focusFontNameInput();
            // イベント解除
            this.removeKeydownEventListener();
            e.preventDefault();
        }
    }

    private focusFontNameInput()
    {
        this.unlockTextEditorFocus();
        this.$nextTick(() => 
        {
            let input = this.$refs["fontname-input"] as HTMLInputElement;
            if(input == null) return;
            input.focus();
        });
    }

    private onFontNameInputChanged(e : Event)
    {
        let input = e.target as HTMLInputElement;
        if(input == null) return;
        this.updatefontDropdownItems(input.value);
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigUnderLineColor(){
        var style = {
            backgroundColor : this.userConfigColor
        };
        return style;
    }

    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }

    private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }

    private get fontStyle()
    {
        if(this.selectedFontId == null) return {};
        var fontId = this.selectedFontId;
        return {
            'font-family' : this.getFontFamily(fontId),
            'font-weight' : this.getFontWeight(fontId)
        };
    }

    private getFontFamily(fontId : string)
    {
        var fontManager : FontManager = this.$store.getters.fontManager;
        return fontManager.getFontFamilyName(fontId);
    }

    private getFontWeight(fontId : string) : string
    {
        var fontManager : FontManager = this.$store.getters.fontManager;
        var font = fontManager.getFontFamilyById(fontId);
        if(font.weight == null) { return "normal"; }
        return font.weight.toString();
    }
}
